(() => {
  try {
    const c = window.console || {} as Console;
    const parentConsole: any = (() => {
      try {
        if (window.parent && window.parent !== window && (window.parent as any).console) {
          return (window.parent as any).console;
        }
      } catch {}
      return null;
    })();

    /** Vite HMR client spams `[vite] connecting…` / `connected` — not useful in the app console. */
    function suppressViteClientNoise(args: unknown[]): boolean {
      const first = args[0];
      return typeof first === "string" && first.includes("[vite]");
    }

    const methodNames: (keyof Console)[] = ['log', 'info', 'debug', 'warn', 'error'];

    methodNames.forEach((name) => {
      const orig = typeof c[name] === 'function' ? (c[name] as any).bind(c) : null;
      (c as any)[name] = (...args: any[]) => {
        if (
          (name === "log" || name === "info" || name === "debug") &&
          suppressViteClientNoise(args)
        ) {
          return;
        }
        try { if (orig) orig(...args); } catch {}
        try { if (parentConsole && typeof parentConsole[name] === 'function') parentConsole[name](...args); } catch {}
      };
    });
  } catch {}
})();
